import React from 'react';
import classNames from 'classnames';
import i18n from 'i18next';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import getVersioningStatusString from '../helpers/getVersioningStatusString';

import styles from '../styles/publishLocalesModal.module.scss';

const PublishLocalesModalVersionStatus = ({
  hasUnpublishedChanges = false,
  isPublished = false,
  publishedAt = null,
  status = null,
  updatedAt = null,
}) => {
  const { lang } = document.documentElement;
  const date = new Date(updatedAt).toLocaleString(lang, { dateStyle: 'short' });
  const isInReview = status === 'in_review';
  const isApproved = status === 'approved';
  const shouldShowLabel = hasUnpublishedChanges || isInReview || isApproved;

  return (
    <div className={styles.status}>
      <Typo className={classNames(styles.body)} variant="s01" element="span">
        {getVersioningStatusString({ isPublished, publishedAt, updatedAt })}
      </Typo>
      {shouldShowLabel && (
        <div className={styles.bodyContainer}>
          {hasUnpublishedChanges && (
            <Typo className={classNames(styles.body)} variant="s01" element="span">
              {i18n.t('unpublished-changes')}
            </Typo>
          )}
          {isApproved && (
            <Typo className={classNames(styles.body)} variant="s01" element="span">
              {i18n.t('approved-date', { date })}
            </Typo>
          )}
          {isInReview && (
            <Typo className={classNames(styles.body)} variant="s01" element="span">
              {i18n.t('submitted-for-review-date', { date })}
            </Typo>
          )}
        </div>
      )}
    </div>
  );
};

PublishLocalesModalVersionStatus.propTypes = {
  hasUnpublishedChanges: PropTypes.bool,
  isPublished: PropTypes.bool,
  publishedAt: PropTypes.string,
  status: PropTypes.oneOf(['approved', 'editing', 'in_review', 'in_translation', null]),
  updatedAt: PropTypes.string,
};

export default PublishLocalesModalVersionStatus;
